import Wrapper from 'components/wrapper';

function App() {
  return <Wrapper />;
}

export default App;
